import { Component, OnInit, Inject, ViewChild, Input } from '@angular/core';

import { AsyncJobDialogBase, JOB_COMPLETED_MESSAGE } from './async-job-base.dialog';
import { AsyncJobService } from '../../services/async-job.service';
import { AsyncJob } from '../../models/async-job.model';
import { ExportFormInstancesMetrics } from '../../models/export-import/export-form-instances-metrics.model';

export abstract class ExportAsyncJobDialogBase extends AsyncJobDialogBase {
    // Properties.
    private downloadExportedDataUrl: string = null;
    private exportJobCompletedCallback: any = null;
    private exportJobUpdatedCallback: any = null;
    private exportTimeoutTimeInMilliseconds: number = 1000; // Default value only.

    // Methods called by HTML code.
    public get ExportStatus(): string {
        let status: string = null;

        if ((!this.jobInProgress) && (this.asyncJobInfo == null)) {
            status = 'Not started';
        } else if (this.jobInProgress) {
            status = 'Export in progress';
        } else if (!this.jobErrorOccurred) {
            if (this.downloadExportedDataUrl != null) {
                status = "Completed -- click 'Download' to save exported data";
            } else {
                status = JOB_COMPLETED_MESSAGE;//'Completed';
            }
        } else {
            status = 'An export error occurred';
            if (this.jobErrorText) {
                status = this.jobErrorText;
            }
        }

        return (status);
    }

    public get ExportedDataUrl(): string {
        return this.downloadExportedDataUrl;
    }
    public set ExportedDataUrl(url: string) {
        this.downloadExportedDataUrl = url;
    }

    // Method to start monitoring a job.
    /*
    protected startMonitoringJob(asyncJobInfo: AsyncJob,
        exportJobCompletedCallback: (asyncJob: AsyncJob) => void,
        jobUpdatedCallback: (asyncJob: AsyncJob) => void = null,
        //saveAppData: boolean = false,
        timeoutTimeInMilliseconds: number = 1000): void {

        // Save the provided data.
        this.asyncJobInfo = asyncJobInfo;
        this.asyncJobInfo.appData = this.getAppDataForRestoration(this.asyncJobInfo);
        this.exportJobCompletedCallback = exportJobCompletedCallback;
        this.exportJobUpdatedCallback = jobUpdatedCallback;
        this.exportTimeoutTimeInMilliseconds = timeoutTimeInMilliseconds;

        // Update status and set a recurring timeout.
        this.jobInProgress = true;
        this.intervalTimeoutId = setInterval(this.handleIntervalTimeout, this.exportTimeoutTimeInMilliseconds);

        return;
    }
    */

    // Protected methods.
    protected static parseExportFormInstancesMetrics(jobMetricsJson: string): ExportFormInstancesMetrics {
        let jobCompletedMessageJson: Object = JSON.parse(jobMetricsJson);
        let importMetrics: ExportFormInstancesMetrics = new ExportFormInstancesMetrics(jobCompletedMessageJson);

        return (importMetrics);
    }
}
